export function formatCurrency(value, currency = 'USD', minimumFractionDigits = 0) {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    minimumFractionDigits,
    currency
  });
  return formatter.format(parseFloat(value));
}

export function formatDelay(value) {
  const val = 0 - value;

  if (val < 1) {
    return '';
  }
  return `${val} Day${val > 1 ? 's' : ''} Late`;
}

export function formatOverdue(value) {
  const val = 0 - value;
  if (val === '') {
    return '';
  }
  if (val === 0) {
    return 'Due today';
  }
  if (val > 0) {
    return `Not due yet ${val} Day${val > 1 ? 's' : ''}`;
  }
  return `${Math.abs(val)} Day${val > 1 ? 's' : ''} Late`;
}

export function convertSnakeCaseToCamelCaseAndCapitalize(text) {
  return text.split('_').map((it) => (it.charAt(0).toUpperCase() + it.slice(1))).join(' ');
}
